import script from "./EAudioPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./EAudioPlayer.vue?vue&type=script&lang=ts&setup=true"

import "./EAudioPlayer.vue?vue&type=style&index=0&id=f82bf166&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f82bf166"]])

export default __exports__